import { apiClient } from "./client";

interface SaveSubscriptionRequest {
  endpoint: string;
  keys: {
    p256dh: string;
    auth: string;
  };
}

interface DeactivateSubscriptionRequest {
  endpoint: string;
}

export async function saveSubscription(subscription: PushSubscriptionJSON): Promise<void> {
  const { endpoint, keys } = subscription;
  if (!endpoint || !keys?.p256dh || !keys?.auth) {
    throw new Error("Invalid subscription: missing endpoint or keys");
  }

  await apiClient.post("/project-management/api/push/subscriptions", {
    endpoint,
    keys: { p256dh: keys.p256dh, auth: keys.auth },
  } satisfies SaveSubscriptionRequest);
}

export async function deactivateSubscription(endpoint: string): Promise<void> {
  await apiClient.patch("/project-management/api/push/subscriptions", {
    endpoint,
  } satisfies DeactivateSubscriptionRequest);
}

export async function sendTestPush(): Promise<void> {
  await apiClient.post("/project-management/api/push/test");
}
